export { MegaMenuResourcesMobile } from "./MegaMenuResourcesMobile";
